import { alpha, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  bodyRow: {
    alignSelf: 'stretch',
    background: alpha('#fdfdfe', 0.1),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
    padding: '0 10px 0 0',
    borderRadius: '6px',
    height: '43px',
  },
  selectWrapper: {
    flex: 1,
    // Same CSS-variable-fallback issue as .menu below: the shared Select's
    // own .trigger rule falls back to a white background/dark text this app
    // hasn't themed via CSS variables, so it needs !important here too.
    '& .select-trigger': {
      color: '#fdfdfe !important',
      background: 'transparent !important',
      border: 'none !important',
      outline: 'none !important',
      fontSize: '16px !important',
      fontFamily: 'Roboto !important',
    },
    '& .select-trigger::placeholder': {
      color: '#FFFFFF99 !important',
      fontSize: '16px !important',
      fontFamily: 'Roboto !important',
    },
  },
  menu: {
    background: '#513E52 !important',
    color: '#fff !important',
    borderRadius: '6px',
    '& .select-no-options': {
      color: '#fff !important',
      fontFamily: 'Roboto !important',
      fontSize: '16px !important',
      textAlign: 'left !important',
    },
  },
  option: {
    fontSize: '16px !important',
    fontFamily: 'Roboto !important',
    fontWeight: '300 !important',
    color: '#fff !important',
    '& .select-option-label': {
      fontFamily: 'Roboto !important',
      fontWeight: '300 !important',
    },
    minHeight: '43px !important',
    '&:hover, &.optionHovered, &.optionSelected': {
      backgroundColor: '#FFFFFF2E !important',
    },
  },
  arrowIcon: {
    color: '#FFFFFF99',
    fontSize: '24px',
    marginLeft: '4px',
    textAlign: 'right',
  },
  divider: {
    marginRight: '10px',
    background: '#AAA2AA',
    width: '1px',
    alignSelf: 'stretch',
  },
}));
